module.exports = "/_next/static/images/sreetam-4c9d55c57a6ad04bee38a05fee95f732.png";